import ReactMarkdown from "markdown-to-jsx";

import { StaticTip } from "components/staticTip/staticTip";
import CommonHero from "components/commonHero/commonHero";
import { PlanCard } from "./components/planCard/planCard";
import type { SubscribePageProps } from "./fetcher";
import FaqBlock from "components/faqBlock/faqBlock";

type SubscribeViewProps = {
  data: SubscribePageProps;
};

const SubscribeView = ({ data }: SubscribeViewProps) => {
  return (
    <>
      <main data-page-type="subscribe" className="bg-[#f6f6f6]">
        <div className="relative">
          <div
            className={
              "pb-[20px] pt-[60px] md:pb-[44px] lg:pb-[65px] lg:pt-[69px]"
            }
          >
            <CommonHero
              title={
                <span>
                  <span className="text-cerise">~/ </span>
                  {data.title}
                </span>
              }
              subtitle={data.subtitle}
              brandColor={"cerise"}
            />
          </div>
          <div
            className={
              "max-w-[1140px] px-5 pb-[100px] md:mx-auto lg:max-w-[1220px] lg:px-0"
            }
          >
            <ul
              className={
                "mb-[30px] flex flex-col gap-[22px] sm:grid md:grid-cols-2 lg:grid-cols-4"
              }
              aria-label={"Subscription tiers list"}
            >
              {data.tiers.map((el) => {
                return (
                  <li key={el.id} aria-label={"Subscription tier"}>
                    <PlanCard {...el} />
                  </li>
                );
              })}
            </ul>
            {data.informationBlock.length > 0 && (
              <ul
                className={"mb-[60px] flex flex-col gap-4 md:mb-[90px]"}
                aria-label={"Information list"}
              >
                {data.informationBlock.map(
                  ({ id, title, titleColour, text }) => {
                    return (
                      <li key={id} aria-label={"Information"}>
                        <StaticTip
                          headingText={title}
                          titleColorOverride={titleColour}
                        >
                          <div className="text-[16px] [&_li]:list-inside [&_li]:list-disc">
                            <ReactMarkdown options={{ forceBlock: false }}>
                              {text}
                            </ReactMarkdown>
                          </div>
                        </StaticTip>
                      </li>
                    );
                  }
                )}
              </ul>
            )}
            {data.faq.length > 0 && (
              <div className={"flex flex-col gap-[60px]"}>
                <div className={"flex justify-center"}>
                  <h2
                    className={
                      "relative font-recklessBold text-[32px] leading-[130%] after:absolute after:bottom-[-22px] after:right-[calc(50%_-_16px)] after:h-[5px] after:w-[32px] after:bg-black-rock after:content-['']"
                    }
                  >
                    {data.faqBlockTitle}
                  </h2>
                </div>
                <FaqBlock list={data.faq} />
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default SubscribeView;
